module.exports = __webpack_public_path__ + "img/resp_card_css.667c9fc3.png";